import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".js-services-left").forEach((section) => {
	let tl = gsap.timeline({ paused: true });

	const title = section.querySelector(".js-title");

	tl.fromTo(
		title,
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			stagger: 0.1,
		},
		0,
	);

	const text = section.querySelector(".js-text");

	const button_area = section.querySelector(".js-button-area");

	let bottom_tl = gsap.timeline({ paused: true });

	bottom_tl.fromTo(
		[text, button_area],
		{
			opacity: 0,
			y: "0.625rem",
		},
		{
			opacity: 1,
			y: 0,
			stagger: 0.1,
		},
		0,
	);

	let mm = gsap.matchMedia();

	mm.add("(min-width: 769px)", () => {
		ScrollTrigger.create({
			trigger: section,
			start: "top top+=50%",
			onEnter: () => {
				tl.play();
			},
			onLeaveBack: () => {
				tl.reverse();
			},
		});

		ScrollTrigger.create({
			trigger: section,
			start: "top top",
			onEnter: () => {
				bottom_tl.play();
			},
			onLeaveBack: () => {
				bottom_tl.reverse();
			},
		});
	});

	mm.add("(max-width: 768px)", () => {
		ScrollTrigger.create({
			trigger: section,
			start: "top top+=50%",
			onEnter: () => {
				tl.play();
			},
			onLeaveBack: () => {
				tl.reverse();
			},
		});

		ScrollTrigger.create({
			trigger: section,
			start: "top top+=50%",
			onEnter: () => {
				bottom_tl.play();
			},
			onLeaveBack: () => {
				bottom_tl.reverse();
			},
		});
	});
});
